import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { adminAPI, gameAPI } from '../../utils/api';

const MassEmailTab = () => {
  const [target, setTarget] = useState('all');
  const [gameId, setGameId] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [games, setGames] = useState([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await gameAPI.getAllGames();
        if (res.success) setGames(res.games || []);
      } catch (e) { /* ignore */ }
    })();
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      toast.error('Bitte Betreff und Nachricht ausfüllen.');
      return;
    }
    if (target === 'game' && !gameId) {
      toast.error('Bitte ein Spiel auswählen.');
      return;
    }
    if (!window.confirm('E-Mail wirklich versenden?')) return;

    setSending(true);
    try {
      const res = await adminAPI.sendMassEmail({
        target,
        gameId: target === 'game' ? Number(gameId) : undefined,
        subject: subject.trim(),
        message: message.trim(),
      });
      toast.success(res.message || 'E-Mail versendet.');
      setSubject('');
      setMessage('');
    } catch (err) {
      const msg = err.response?.data?.error || 'Versand fehlgeschlagen.';
      toast.error(msg);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="massmail-tab">
      <h3>Massen-E-Mail</h3>
      <p className="dash-empty" style={{ marginBottom: '1rem' }}>
        Sende eine E-Mail an alle Mitglieder oder gezielt an die Angemeldeten eines Spiels.
        Empfänger werden per BCC verschickt (Adressen bleiben privat).
      </p>

      <form onSubmit={handleSend} className="massmail-form">
        <div className="form-group">
          <label>Empfänger</label>
          <div className="massmail-targets">
            <label className="radio-inline">
              <input type="radio" name="target" value="all" checked={target === 'all'} onChange={() => setTarget('all')} />
              Alle Mitglieder
            </label>
            <label className="radio-inline">
              <input type="radio" name="target" value="game" checked={target === 'game'} onChange={() => setTarget('game')} />
              Angemeldete eines Spiels
            </label>
          </div>
        </div>

        {target === 'game' && (
          <div className="form-group">
            <label htmlFor="game">Spiel</label>
            <select id="game" value={gameId} onChange={(e) => setGameId(e.target.value)}>
              <option value="">– Spiel wählen –</option>
              {games.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.opponent} ({new Date(g.game_date).toLocaleDateString('de-DE')})
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="subject">Betreff</label>
          <input id="subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="z.B. Infos zur Auswärtsfahrt" required />
        </div>

        <div className="form-group">
          <label htmlFor="message">Nachricht</label>
          <textarea id="message" rows={10} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Deine Nachricht an die Mitglieder …" required />
        </div>

        <button type="submit" className="btn btn-primary" disabled={sending}>
          {sending ? 'Wird versendet …' : 'E-Mail senden'}
        </button>
      </form>
    </div>
  );
};

export default MassEmailTab;
